export default __webpack_public_path__ + "assets/mp3/4551b38f8db4485841aa9bf9e2bb7834.mp3";